import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import L from 'leaflet';

import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

// Fix default icon issue with Leaflet in React
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Custom red icon for admin pins (make sure redMarker.png is in public/)
const redIcon = new L.Icon({
  iconUrl: '/marker-icon-violet.png',
  iconRetinaUrl: '/marker-icon-violet.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

type Pin = {
  name: string;
  lat: number;
  lng: number;
  description: string;
};

const Map: React.FC = () => {
  const [pins, setPins] = useState<Pin[]>([]);
  const [adminPins, setAdminPins] = useState<Pin[]>([]);

  useEffect(() => {
    fetch('/pins_no_duplicates.json')
      .then(res => res.json())
      .then(data => setPins(data));
  }, []);

  useEffect(() => {
    fetch('/adminpins.json')
      .then(res => res.json())
      .then(data => setAdminPins(data));
  }, []);

  // Center the map on the first pin or a default location
  const center: [number, number] = pins.length
    ? [pins[0].lat, pins[0].lng]
    : [51.1, 17.0];

  return (
  <div className="map-page" style={{ height: '80vh', width: '100%' }}>
    <MapContainer center={center} zoom={12} style={{ height: '100%', width: '100%' }}>
      <TileLayer
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* Cluster only normal pins */}
      <MarkerClusterGroup maxClusterRadius={15}>
        {pins.map((pin, idx) => (
          <Marker key={idx} position={[pin.lat, pin.lng]}>
            <Popup>
              <strong>{pin.name}</strong>
              <br />
              {pin.description}
            </Popup>
          </Marker>
        ))}
      </MarkerClusterGroup>
      {/* Admin pins are NOT clustered */}
      {adminPins.map((pin, idx) => (
        <Marker key={`admin-${idx}`} position={[pin.lat, pin.lng]} icon={redIcon}>
          <Popup>
            <strong>{pin.name}</strong>
            <br />
            {pin.description}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  </div>
  );
};

export default Map;